import AdminHistoryContainer from './AdminHistoryContainer';
export default AdminHistoryContainer;
